import { useMutation } from '@tanstack/react-query';
import { useApiClientContext } from '../../surveys/context';
import { ICustomSurveyResponse, IOperationResultNoValue } from '../../surveys/models/Api';

export const useClientUpdateCustomSurveyResponseMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: IOperationResultNoValue) => void;
	onSuccess?: (data?: ICustomSurveyResponse) => void;
}) => {
	const { apiClient } = useApiClientContext();

	return useMutation({
		mutationFn: ({ body, accessToken }: { accessToken: string; body: ICustomSurveyResponse }) => {
			return apiClient.put<ICustomSurveyResponse>(`survey/custom/response?token=${accessToken}`, body);
		},
		onError,
		onSuccess,
	});
};
